"use client";

import { type PropsWithChildren, type Ref } from "react";

import cn from "../../utils/cn.util";
import { useCardContext } from "./context";
import { footerStyles } from "./styles";

export type CardFooterProps = PropsWithChildren<{
  className?: string;
  ref?: Ref<HTMLDivElement>;
}>;

export const Footer = ({ ref, children, className }: CardFooterProps & {}) => {
  const { variant } = useCardContext();

  return (
    <div className={cn(footerStyles({ variant }), className)} ref={ref}>
      {children}
    </div>
  );
};

Footer.displayName = "CardFooter";
